// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchUpsell-cls1_JRo","cls2":"SearchUpsell-cls2_n2Y SearchUpsell-cls1_JRo"};